export default __webpack_public_path__ + "static/media/Snd_01.829a3f30.mp3";